<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection class="relative">
          <ThreeDotsMenu v-if="chartData">
            <template v-slot:trigger>
              <ArgonButton
                class="d-flex gap-1 align-items-center"
                type="button"
              >
                Export&nbsp;
                <span>
                  <i
                    class="fas fa-chevron-down cursor-pointer"
                    aria-hidden="true"
                  ></i>
                </span>
              </ArgonButton>
            </template>
            <button
              type="button"
              class="text-secondary font-weight-bold text-xs border-0 bg-transparent"
              @click="convertToCSV"
            >
              Export ke CSV
            </button>
            <button
              type="button"
              class="text-secondary font-weight-bold text-xs border-0 bg-transparent"
              @click="printPage"
            >
              Export ke PDF
            </button>
          </ThreeDotsMenu>
        </MetaSection>
      </GridCol>

      <GridCol :size="12" class="pb-4">
        <div class="d-flex align-items-center justify-content-start gap-2">
          <div class="d-flex justify-content-start w-100 gap-2">
            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="params.periode_id"
                :list="
                  list_periode.sort((a, b) => a.name.localeCompare(b.name))
                "
                option-value="id"
                option-text="name"
                placeholder="Pilih Periode"
              />
            </FormGroup>

            <FormGroup class="m-0 filter">
              <model-list-select
              class="form-control"
              v-model="params.unitkerja_id"
              :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
              option-value="id"
              option-text="name"
              placeholder="Pilih Unit Kerja"
              />
            </FormGroup>

            <FormGroup class="m-0 filter">
              <input v-model="params.search" @keyup="searchKeyword()" type="text" class="form-control" placeholder="Cari nama pegawai..." />
            </FormGroup>

            <FormGroup class="m-0 filter">
              <button
                type="button"
                class="btn btn-link"
                @click="resetFilter()"
                v-if="params.periode_id"
              >
                Reset
              </button>
            </FormGroup>
          </div>
        </div>
      </GridCol>

      <GridCol :size="12">
        <CardComponent :useHeader="true" :withmin="false">
          <!-- <template v-slot:header-action>
            header
          </template> -->

          <div
            class="d-flex justify-content-center text-center border py-10"
            v-if="!showData"
          >
            <h5>Pilih Periode Terlebih Dahulu</h5>
          </div>

          <div v-else id="print-section" ref="printSection">
            <div class="title-print text-center pb-4 visually-hidden">
              <h3>Laporan Semua Pegawai</h3>
              <h2>Periode {{ list_periode?.filter(item => item.id === params.periode_id)?.[0]?.name || '-' }}</h2>
            </div>

            <div class="d-flex flex-column gap-5">
              <div id="table-section">
                <div class="mb-2 d-flex items-center justify-content-between">
                  <h5>Daftar Karyawan</h5>
                </div>

                <ListView
                  :thead="!params?.unitkerja_id && !params?.search ? [
                    'No.',
                    'NIP',
                    'Nama',
                    'Unit Kerja',
                    'Jabatan',
                    'Nilai Kinerja',
                    'Nilai Kompetensi',
                    'Total Penugasan',
                    'Total Pengurangan',
                    'Nilai Akhir',
                    'Yudisium',
                    'Standar Z',
                    'Distribusi Normal',
                  ] : [
                    'No.',
                    'NIP',
                    'Nama',
                    'Unit Kerja',
                    'Jabatan',
                    'Nilai Kinerja',
                    'Nilai Kompetensi',
                    'Total Penugasan',
                    'Total Pengurangan',
                    'Nilai Akhir',
                    'Yudisium',
                  ]"
                  class="table-limit"
                >
                  <template v-slot:tbody>
                    <!-- <tr v-if="data.length < 1">
                      <td colspan="7" class="text-center text-secondary">Tidak ada data</td>
                    </tr> -->
                    <!-- <tr v-for="(item, index) in data" :key="index">
                      <td>{{ item.nip || "-" }}</td>
                      <td class="font-weight-bold">{{ item.name || "-" }}</td> -->

                    <!-- <tr v-for="(item, index) in 10" :key="index">
                      <td>{{ item }}</td>
                      <td>Muhammad Satrio Nugroho</td>
                      <td>Pengelola</td>
                      <td>4.00</td>
                      <td>
                        <ArgonBadge color="warning" class="text-warning" v-if="item === 8 || item === 9">Cukup</ArgonBadge>
                        <ArgonBadge color="danger" v-else-if="item === 10">Kurang</ArgonBadge>
                        <ArgonBadge v-else>Baik</ArgonBadge>
                      </td>
                      <td>1.24</td>
                      <td>0.6</td>
                    </tr> -->

                    <tr v-if="!chartData?.data || chartData?.data?.length < 1">
                      <td colspan="13" class="text-center text-secondary">
                        Tidak ada data
                      </td>
                    </tr>

                    <tr v-for="(item, index) in chartData?.data" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item?.nip || "-" }}</td>
                      <td>{{ item?.name || "-" }}</td>
                      <td class="text-wrap">
                        {{ item?.unitkerja || "-" }}
                      </td>
                      <td width="500" class="text-wrap">
                        {{ item?.jabatan || "-" }}
                      </td>
                      <td>{{ item?.nilai_kinerja || item?.nilai_kinerja === 0 ? item?.nilai_kinerja : "-" }}</td>
                      <td>{{ item?.nilai_kompetensi || item?.nilai_kompetensi === 0 ? item?.nilai_kompetensi : "-" }}</td>
                      <td>{{ item?.total_penugasan || item?.total_penugasan === 0 ? item?.total_penugasan : "-" }}</td>
                      <td>{{ item?.total_pengurangan || item?.total_pengurangan === 0 ? item?.total_pengurangan : "-" }}</td>
                      <td>{{ item?.nilai_akhir || item?.nilai_akhir === 0 ? item?.nilai_akhir : "-" }}</td>
                      <td>
                        <ArgonBadge
                          v-if="
                            item?.indeks_penilaian_akhir?.toLocaleLowerCase() === 'a'
                          "
                          >{{ item?.indeks_penilaian_akhir }}</ArgonBadge
                        >
                        <ArgonBadge
                          v-else-if="
                            item?.indeks_penilaian_akhir?.toLocaleLowerCase() === 'b'
                          "
                          color="info"
                          >{{ item?.indeks_penilaian_akhir }}</ArgonBadge
                        >
                        <ArgonBadge
                          color="warning"
                          class="text-warning"
                          v-else-if="
                            item?.indeks_penilaian_akhir?.toLocaleLowerCase() === 'c'
                          "
                          >{{ item?.indeks_penilaian_akhir }}</ArgonBadge
                        >
                        <ArgonBadge color="danger" v-else>{{
                          item?.indeks_penilaian_akhir
                        }}</ArgonBadge>
                      </td>
                      <template v-if="!params?.unitkerja_id && !params?.search">
                        <td>{{ item?.z_score || item?.z_score === 0 ? item?.z_score : "-" }}</td>
                        <td>{{ item?.normal_distribution || item?.normal_distribution === 0 ? item?.normal_distribution : "-" }}</td>
                      </template>
                    </tr>
                  </template>
                </ListView>
              </div>
            </div>

            <div class="result" v-if="!params?.unitkerja_id && !params?.search">
              <div
                class="result-value d-flex align-items-center justify-content-between border-b border-primary"
              >
                <span>Nilai Rata-rata</span>
                <strong>{{ chartData?.summary?.avg || "-" }}</strong>
              </div>
              <div
                class="result-value d-flex align-items-center justify-content-between border-b border-primary"
              >
                <span>Standar Deviasi</span>
                <strong>{{ chartData?.summary?.stddev || "-" }}</strong>
              </div>
            </div>

            <!-- </template> -->
          </div>
        </CardComponent>
      </GridCol>
    </GridRow>

  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent.vue";
// import InputGroup from '@/components/InputGroup.vue';
// import LaporanSummaryApi from '@/repository/api/LaporanSummaryApi';
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import LaporanKurvaNormalApi from "@/repository/api/LaporanKurvaNormalApi";
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import ListView from "@/components/ListView.vue";
import FormGroup from "@/components/FormGroup.vue";
// import ArgonPagination from '@/components/ArgonPagination.vue';
import ArgonBadge from "@/components/ArgonBadge.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
// import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
// import Chart from "chart.js/auto";
import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: "tables",
  components: {
    CardComponent,
    // InputGroup,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    FormGroup,
    // ArgonPagination,
    ArgonBadge,
    ArgonButton,
    ModelListSelect,
    // FieldsetComponent,
    ThreeDotsMenu,
  },
  data() {
    return {
      moment,
      timer: undefined,
      // data: [],
      list_periode: [],
      unitkerja: [],

      params: {
        periode_id: "",
        unitkerja_id: "",
        page: "all",
        search: '',
      },

      model: {
        nilai: "",
        rata_rata: "",
      },

      chartInstance: null,
      chartDonutInstance: null,
      chartBarInstance: null,

      showData: false,
      chartData: null,
    };
  },
  watch: {
    // params: {
    //   handler(newValue) {
    //     if (newValue.periode_id || newValue.unitkerja_id) this.getChartData();
    //   },
    //   deep: true,
    // },
    'params.periode_id'() {
      this.getChartData();
    },
    'params.unitkerja_id'() {
      this.getChartData();
    }
  },
  methods: {
    async printPage() {
      const printEl = this.$refs.printSection;
      if (!printEl) return;

      // fix table limit scroll for full render
      const tableLimit = printEl.querySelector(".table-limit");
      let originalMaxHeight;

      if (tableLimit) {
        originalMaxHeight = tableLimit.style.maxHeight;
        tableLimit.style.maxHeight = "unset";
        tableLimit.style.overflow = "visible";
      }

      await this.$nextTick();

      const pdf = new jsPDF("p", "mm", "a4");
      const margin = 15;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const usableWidth = pageWidth - margin * 2;

      /* =======================================================
      * 1. BUILD MERGED TEMP CONTAINER (TITLE + TABLE + RESULT)
      * ======================================================= */

      const titleSection = printEl.querySelector(".title-print");
      const tableSection = printEl.querySelector(
        ".d-flex.flex-column.gap-5 > div:nth-child(1)"
      );
      const resultSection = printEl.querySelector(".result");

      const tempContainer = document.createElement("div");
      tempContainer.style.padding = "20px";
      tempContainer.style.background = "#ffffff";
      tempContainer.style.width = tableSection.offsetWidth + "px";

      const clonedTitle = titleSection.cloneNode(true);
      clonedTitle.classList.remove("visually-hidden");

      tempContainer.appendChild(clonedTitle);
      tempContainer.appendChild(tableSection.cloneNode(true));
      tempContainer.appendChild(resultSection.cloneNode(true));

      document.body.appendChild(tempContainer);

      /* =======================================================
      * 2. Convert semua (title + table + result) menjadi 1 canvas
      * ======================================================= */

      const fullCanvas = await html2canvas(tempContainer, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      document.body.removeChild(tempContainer);

      const fullHeight =
        (fullCanvas.height * usableWidth) / fullCanvas.width;

      let yOffset = 0;
      let pageY = margin;

      /* =======================================================
      * 3. MULTI-PAGE CUTTING
      * ======================================================= */

      while (yOffset < fullHeight) {
        const remaining = fullHeight - yOffset;
        const heightToDraw = Math.min(remaining, pageHeight - pageY - margin);

        const srcY = (yOffset / fullHeight) * fullCanvas.height;
        const srcH = (heightToDraw / fullHeight) * fullCanvas.height;

        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = fullCanvas.width;
        croppedCanvas.height = srcH;

        const ctx = croppedCanvas.getContext("2d");
        ctx.drawImage(
          fullCanvas,
          0,
          srcY,
          fullCanvas.width,
          srcH,
          0,
          0,
          fullCanvas.width,
          srcH
        );

        const croppedImg = croppedCanvas.toDataURL("image/jpeg", 0.85);

        pdf.addImage(croppedImg, "JPEG", margin, pageY, usableWidth, heightToDraw);

        yOffset += heightToDraw;

        if (yOffset < fullHeight) {
          pdf.addPage();
          pageY = margin;
        }
      }

      // restore table limit
      if (tableLimit) {
        tableLimit.style.maxHeight = originalMaxHeight;
        tableLimit.style.overflow = "auto";
      }

      pdf.save(`laporan_semua_pegawai_${this.moment().unix()}.pdf`);
    },
    convertToCSV() {
      const csvData = this.convertJSONToCSV(
        this.chartData?.data?.map((item) => {
          return {
            nip: item?.nip ?? "",
            name: item?.name ?? "",
            unit_kerja: item?.unitkerja ?? "",
            jabatan: item?.jabatan ?? "",
            nilai_kinerja: item?.nilai_kinerja ?? "",
            nilai_kompetensi: item?.nilai_kompetensi ?? "",
            total_penugasan: item?.total_penugasan ?? "",
            total_pengurangan: item?.total_pengurangan ?? "",
            nilai_akhir: item?.nilai_akhir ?? "",
            yudisium: item?.indeks_penilaian_akhir ?? "",
            z_score: item?.z_score ?? "",
            normal_distribution: item?.normal_distribution ?? "",
          };
        })
      );
      this.downloadCSV(
        csvData,
        `laporan_semua_pegawai_${this.moment().unix()}.csv`
      );
    },
    convertJSONToCSV(jsonData) {
      const headers = Object.keys(jsonData[0]);
      const csvRows = [];

      csvRows.push(headers.join(","));

      jsonData.forEach((row) => {
        const values = headers.map((header) => {
          const value = row[header];
          return JSON.stringify(value);
        });
        csvRows.push(values.join(","));
      });

      return csvRows.join("\n");
    },
    downloadCSV(csvData, filename) {
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async getChartData() {
      this.$store.state.loading = true;
      this.chartData = null;
      this.showData = false;

      await LaporanKurvaNormalApi.getKurvaNormalPegawai(this.params)
        .then((response) => {
          this.showData = true;

          this.chartData = response?.data || null;
          setTimeout(() => {
            this.createChart();
            this.createChartDonut();
            this.createChartBar();
          }, 50);
        })
        .catch(() => {
          // this.list_periode = [];
          this.showData = false;
          this.chartData = null;
        });
      this.$store.state.loading = false;
    },
    async getPeriode() {
      await KpiPeriodeApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.list_periode = response?.data;
          // this.params.periode_id = this.list_periode?.[0]?.id || '';
        })
        .catch(() => {
          this.list_periode = [];
        });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.unitkerja = response.data;
        })
        .catch(() => {
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },
    async searchKeyword() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        if (this.params?.periode_id)
          await this.getChartData();
      }, 650)
    },
    resetFilter() {
      this.params.search = ''
      if (this.params?.unitkerja_id) {
        this.params.unitkerja_id = ''
        return
      }

      this.getChartData();
    }
  },
  async mounted() {
    await this.getUnitKerja();
    await this.getPeriode();
  },

  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>

<style>
.chart-wrapper {
  width: 350px; /* fixed width */
  height: 350px; /* fixed height (same as width to keep circle) */
  margin: 0 auto; /* center horizontally */
  display: flex;
  justify-content: center;
  align-items: center;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}

.result {
  background: #d9eafe;
  color: #0385f3;
}
.result .result-value {
  padding: 8px 16px;
}
.result .result-value:nth-child(1) {
  border-bottom: 1px solid #c5e0fe !important;
}

.threedotsmenu-hover {
  width: fit-content !important;
  padding-right: 40px !important;
}

.table-limit {
  max-height: 740px;
  overflow-y: auto;
}

/* PRINT ONLY SPECIFIC AREA */
@media print {
  body * {
    visibility: hidden !important;
  }

  #print-section,
  #print-section * {
    visibility: visible !important;
  }

  .no-print {
    visibility: hidden !important;
  }

  #print-section {
    position: absolute !important;
    inset: 0 !important; /* Shorthand: top:0 left:0 right:0 bottom:0 */
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    box-sizing: border-box !important;

    /* position: absolute; */
    /* left: 0;
    top: 0; */
    /* width: 100% !important; */
    /* margin: 0 !important;
    padding: 0 !important; */

    /* FORCE 1 LONG PAGE */
    /* height: auto !important;
    overflow: visible !important; */
  }

  /* REMOVE ALL EXTRA SPACING BETWEEN BLOCKS */
  /* #print-section > * {
    margin: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    break-after: avoid !important;
    break-before: avoid !important;
  } */

  #print-section > * {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    break-before: avoid !important;
    break-after: avoid !important;
    break-inside: avoid !important;
  }

  /* PREVENT PAGE BREAK INSIDE EVERYTHING */
  #print-section,
  #print-section * {
    break-inside: avoid !important;
    page-break-inside: avoid !important;

    /* padding-top: 0 !important;
    margin: 0 !important; */
  }

  /* Fix for charts & canvas */
  /* canvas {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    display: block !important;
  } */

  canvas#chart-donut-canvas {
    width: 1450px !important;
    height: 280px !important;
  }

  /* Fix for tables */
  /* table {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    border-collapse: collapse !important;
  } */

  .table-limit {
    max-height: fit-content;
    overflow-y: auto;
    width: 100% !important;
  }

  /* Remove page margins */
  @page {
    size: A4 landscape;
    margin: 0 !important;
  }
}
</style>
